<template>
<div v-once id="font_purchase">
	<section class="hero">
		<div class="hero__title">
			<h2 class="h2">フォント購入について</h2>
		</div>
	</section>
	<div class="attention wrapper">
		<p class="attention__txt">現在提供しているデフォルトのフォントは、引き続き無料でお使いいただけます。<br>
			多くのユーザーにリクエストいただいている明朝体とゴシック体も含め、<br class="pc">フォント選択機能は半年間の無料提供期間を経て有料化いたしました。</p>
	</div>
	<section class="second">
		<h2 class="h2">選べるフォント</h2>
		<div class="fontlist wrapper">
			<div class="fontlist__default">
				<p>デフォルト（ゴシック）</p>
				<img src="/static/renew_img/font_lp_img/font_01.png" alt="Noto Sans JP" class="fontlist__shadow">
			</div>
			<div class="fontlist__02 sp-flex">
				<div class="font_block">
					<p>ゴシック</p>
					<img src="/static/renew_img/font_lp_img/font_02.png" alt="yagishゴシック" class="fontlist__shadow">
					<img src="/static/renew_img/font_lp_img/font_03.png" alt="Kosugi" class="fontlist__shadow">
				</div>
				<div class="font_block">
					<p>明朝</p>
					<img src="/static/renew_img/font_lp_img/font_04.png" alt="Noto Serif JP" class="fontlist__shadow">
					<img src="/static/renew_img/font_lp_img/font_05.png" alt="yagish明朝" class="fontlist__shadow">
					<img src="/static/renew_img/font_lp_img/font_06.png" alt="Klee One" class="fontlist__shadow">
				</div>
			</div>
			<div class="fontlist__03 sp-flex">
				<div class="font_block">
					<p>手書き風</p>
					<img src="/static/renew_img/font_lp_img/font_07.png" alt="Kiwi Maru" class="fontlist__shadow">
					<img src="/static/renew_img/font_lp_img/font_08.png" alt="Zen Kurenaido" class="fontlist__shadow">
				</div>
				<div class="font_block">
					<p>個性的!?</p>
					<img src="/static/renew_img/font_lp_img/font_09.png" alt="ドットゴシック16" class="fontlist__shadow">
				</div>
			</div>
		</div>
		<div class="fontmemo wrapper">
			<div class="fontmemo__block">
				<p class="fontmemo__title">フォントが増えたときも、<br>追加購入不要で使えます！</p>
				<p class="fontmemo__txt">※今後のサービス拡大によりフォントが<br>増える可能性があります。</p>
			</div>
		</div>
		<div class="cv-block wrapper">
			<p>＼220円で全て使えます／</p>
          <el-button class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic"
          @click="openFontDialog"
          >フォントまるごとパック<span class="cv-btn_small">を購入</span></el-button>
		</div>
	</section>
	
	<!--使い方-->
	<section class="third">
		<div class="wrapper">
			<h2 class="h2">利用方法</h2>
			<ul class="step">
				<li class="step_item">
					<div class="sp-flex step_center">
						<p class="step_number">①</p>
						<p><span class="step_bold">作成中の画面下の「プレビュー」</span>をクリック！</p>
					</div>
					<img src="/static/renew_img/font_lp_img/step_01.png" alt="作成中の画面下の「プレビュー」をクリック！">
				</li>
				<li class="step_item">
					<div class="sp-flex step_center">
						<p class="step_number">②</p>
						<p><span class="step_bold">プレビュー画面の「フォント変更を利用する」</span>ボタンをクリック！</p>
					</div>
					<img src="/static/renew_img/font_lp_img/step_02.png" alt="プレビュー画面の「フォント変更を利用する」ボタンをクリック！">
				</li>
				<li class="step_item">
					<div class="sp-flex step_item_03">
						<p class="step_number">③</p>
						<p><span class="step_bold">クレジットカード情報を入力し、</span>購入ボタンをクリック！<br>
							<span class="step_small">※お客様のカード情報は保存されません。</span></p>
					</div>
					<img src="/static/renew_img/font_lp_img/step_03.png" alt="クレジットカード情報を入力し、購入ボタンをクリック！">
				</li>
				<li class="step_item">
					<div class="sp-flex step_center">
						<p class="step_number">④</p>
						<p><span class="step_bold">フォントを選択し、</span>「選択したフォントに変更」ボタンをクリック！<br>
							<span class="step_small">※緑の変更ボタンを押さないと履歴書に反映されません。</span></p>
					</div>
					<img src="/static/renew_img/font_lp_img/step_04.png" alt="フォントを選択し、「選択したフォントに変更」ボタンをクリック！">
					<img src="/static/renew_img/font_lp_img/deco02.png" alt="フォントを選んでほしいヤギ" class="deco02">
				</li>
			</ul>
		</div>
		<div class="cv-block wrapper">
			<p>＼220円で全て使えます／</p>
          <el-button class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic"
          @click="openFontDialog"
          >フォントまるごとパック<span class="cv-btn_small">を購入</span></el-button>
			<p class="memo">※プレビュー画面にて利用できます</p>
		</div>
	</section>
	
	<div style="text-align: center; padding: 20px;">
		<a href="/terms" target="_blank">利用規約は<span style="color: #E3165C;">こちら</span></a>
	</div>
</div>
</template>

<style lang="css" src="@/assets/css/font_lp_stylesheet.css"></style>


<script>

export default {
  data: function () {
    return {
    }
  },
  computed: {},
  methods: {
	openFontDialog: function() {
        const app = this
		if (this.$firebase.isAuthenticated) {
          const formData = new FormData()
          formData.append('uuid', this.$firebase.user.uid)

          this.$axios
            .post(this.$varuna.endPoints.getFontpayment, formData, {timeout: 60000})
            .then(function (response) {
              if (response.data.payment_flag == '1') {
                app.$message({
					message: 'すでに購入済みです。ご利用ください。',
					type: 'warning'
				})
              } else {
				app.$eventHub.$emit('open-fontpayment-dialog', 'lp')
			  }
            })
            .catch(function (error) {
            }).finally(function () {
            })

		} else {
			app.$message({
				message: '会員登録が必要です。ログインしてください。',
				type: 'warning'
			})
		}
	},
    getFontpayment: function () {
      
      this.$nextTick(function () {
        console.error(this.$firebase)
        console.error(this.$firebase.isAuthenticated)
        if (this.$firebase.isAuthenticated) {
          const app = this

          const formData = new FormData()
          formData.append('uuid', this.$firebase.user.uid)

          this.$axios
            .post(this.$varuna.endPoints.getFontpayment, formData, {timeout: 60000})
            .then(function (response) {
              if (response.data.payment_flag == '1') {
                app.fontPaymented = true
              }
            })
            .catch(function (error) {
            }).finally(function () {
            })
          
        }
      })
    }
  },
  watch: {},
  created : function(){
    this.getFontpayment()
  },
  mounted: function () {}
}
</script>
